export default __webpack_public_path__ + "static/media/Create-documentation.8fdaf290.md";